export const customerTypeForm = (state, val) => {
  state.customerType = val
}

export const getCustomerType = (state, val) => {
  state.customerTypes = val
}

export const listCustomerType = (state, val) => {
  state.listCustomerTypes = val
}

// customer
export const getCustomer = (state, val) => {
  state.customers = val
}

export const customerForm = (state, val) => {
  state.customer = val
  state.customer.ts = new Date().getTime()
}

export const setCustomerDetail = (state, val) => {
  state.customerDetail = val
}

export const customerFormReset = state => {
  state.customer = {
    number: '',
    name: '',
    area_id: null,
    customer_type_id: null,
    address: '',
    lat: -7.7831651,
    lng: 110.3696965,
    is_customer: 1,
    id: '',
    is_office: 0,
    district_id: null
  }
}

export const getCustomerProject = (state, val) => {
  state.projects = val
}

// customer rating
export const customerRatingForm = (state, val) => {
  state.customerRating = val
}

export const getCustomerRating = (state, val) => {
  state.customerRatings = val
}

export const listCustomerRating = (state, val) => {
  state.listCustomerRatings = val
}

// customer greeting
export const customerGreetingForm = (state, val) => {
  state.customerGreeting = val
}

export const getCustomerGreeting = (state, val) => {
  state.customerGreetings = val
}

export const listCustomerGreeting = (state, val) => {
  state.listCustomerGreetings = val
}

export const getCustomerInstrument = (state, val) => {
  state.customerInstruments = val
}

export const getCustomerCategory = (state, val) => {
  state.customerCategories = val
}

export const getCustomerSegment = (state, val) => {
  state.customerSegments = val
}

export const getCustomerOwnership = (state, val) => {
  state.customerOwnerships = val
}

export const getContact = (state, val) => {
  state.contacts = val
}

export const getContactTitle = (state, val) => {
  state.titles = val
}

export const customerSort = (state, val) => {
  let oldVal = state.customerTableSort

  if (oldVal.sortBy == val) {
    state.customerTableSort.sortDesc = !oldVal.sortDesc
  } else {
    state.customerTableSort = {
      sortBy: val,
      sortDesc: true
    }
  }
}

export const sourceMerge = (state, val) => {
  if (val.check) {
    state.mergeSources.push(val.data)
  } else {
    state.mergeSources = state.mergeSources.filter(u => u.id !== val.data.id)
  }
}

export const resetMerge = state => {
  state.mergeSources = []
}
export const integrationStep = (state, val) => {
  state.iStep = val
}

export const integrationSetForm = (state, val) => {
  val.forEach(v => {
    state.integrationForm[v.key] = v.data
  })
}

export const integrationResetForm = state => {
  state.integrationForm = {
    customer: null,

    npwpCopy: false,
    npwpFile: null,
    npwpFileName: null,
    npwpFileType: null,

    idakCopy: false,
    idakFile: null,
    idakFileName: null,
    idakFileType: null,

    cdakbCopy: false,
    cdakbFile: null,
    cdakbFileName: null,
    cdakbFileType: null,

    nitkuCopy: false,
    nitkuFile: null,
    nitkuFileName: null,
    nitkuFileType: null,

    cpLab: null,
    cpLabTlp: null,
    cpFinance: null,
    cpFinanceTlp: null
  }
}
